import { createApp } from '@app/adapters/create-app'
import createStore from '@app/insights/store'
import getPiniaInstance from '@app/shared/pinia/instance'
import { initInsightsRootFromDataset } from '@app/insights/store/insights-root'
import { useSegmentsOverviewStore } from '@app/insights/segments-overview/store'
import { parseDatasetList } from '@app/utils/parse-dataset-list'
import type { Store } from 'vuex'

import InsightsLeftSubnav from '@app/insights/components/companies/companies-list-progress.vue'
import QueryToolbarHeader from '@app/insights/components/companies/query-toolbar-header.vue'
import type { App as Application } from 'vue'

window.onDomLoad(function ($dom) {
  const doc = $dom[0]
  const element = doc.querySelector(
    "[data-behaviour='insights/subnav-left']"
  ) as HTMLElement

  if (!element) return

  initInsightsRootFromDataset(element.dataset)

  if (element.dataset.insightsQueryOverview === 'true') {
    useSegmentsOverviewStore(getPiniaInstance()).seedPins({
      segment_ids: parseDatasetList<number>(element.dataset.pinnedSegmentIds),
      partner_segment_ids: parseDatasetList<number>(
        element.dataset.pinnedPartnerSegmentIds
      ),
    })

    createApp(QueryToolbarHeader).mount(element)
    return
  }

  const store = createStore() as Store<unknown>

  const leftSubnavApp: Application = createApp(InsightsLeftSubnav, {
    isLite: element.dataset.liteInsights === 'true',
  })

  leftSubnavApp.use(store)
  leftSubnavApp.mount(element)
})
